<template>
  <div>
    <div class="modal fade" id="searchModal" tabindex="-1" role="dialog" aria-labelledby="searchModalLabel"
      aria-hidden="true" style="overflow: auto!important;">
      <div class="modal-dialog modal-dialog-v2" role="document">
        <div class="modal-content modal-content-v2">
          <div class="modal-header modal-header-v2">
            <h5 class="modal-title modal-title-v2" id="searchModalLabel">
              <i class="fa fa-search"></i>
              Пошук
            </h5>
            <button type="button" class="close close-v2" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body modal-body-v2">
            <div class="search-controls-v2">
              <div class="search-input-group-v2">
                <div class="search-input-wrapper-v2">
                  <input type="text" id="search_item" v-model="query" placeholder="Введіть текст для пошуку..."
                    class="search-input-v2" />
                  <i class="fa fa-search search-icon-v2"></i>
                </div>
                <select v-model="selected_option" class="search-select-v2">
                  <option v-for="option in options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>

              <div v-if="loading" class="loading-container-v2">
                <div class="preloader-v2" ref="preloader">
                  <div class="spinner-v2"></div>
                  <span class="loading-text-v2">Пошук...</span>
                </div>
              </div>
            </div>

            <div class="search-results-v2">
              <search-render v-if="!loading" :responseData="responseData" :what="what" :materials="materials"
                :edges="edges" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <recommend-render :materials="materials" :edges="edges" :what="what" />
    <analogs-render :materials="materials" :edges="edges" :what="what" />
  </div>
</template>

<script>
import SearchRender from "./searchRender";
import recommendRender from "./recommendRender.vue";
import analogsRender from "./analogsRender.vue";
import axios from "axios";
import $ from "jquery";

const CancelToken = axios.CancelToken;
export default {
  props: ['what', 'materials', 'edges'],
  data() {
    return {
      loading: false,
      responseData: [],
      options: [
        { text: 'Найменування', value: 'full_name' },
        { text: 'Код', value: 'code' },
        { text: 'Артикул', value: 'article' }
      ],
      query: '',
      selected_option: 'full_name',
      searchItemsSource: null,
      bid_price_items: app.bidPriceItems || []
    }
  },
  watch: {
    query(value) {
      this.responseData = [];
      if (value.length >= 3) {
        this.getSearchProducts(value, this.selected_option)
      }
    },
    selected_option(value) {
      if (value && this.query.length >= 3) {
        this.getSearchProducts(this.query, value)
      }
    },
    what() {
      this.responseData = [];
      this.query = '';
    }
  },
  methods: {
    getSearchProducts(item, select) {

      if (this.searchItemsSource) {
        this.searchItemsSource.cancel('Cancel previous request');
      }
      this.searchItemsSource = CancelToken.source();
      this.loading = true;
      return axios.post(appconfig.Point + 'api/constructor/v1/' + this.what, {
        by: select,
        search: item,
        take: 20,
        token: (this.$store.state.auth.user.token || null)
      }, {
        cancelToken: this.searchItemsSource.token
      })
        .then(response => {
          this.responseData = response.data;
          this.loading = false;
        })
        .catch(e => {
          if (axios.isCancel(e)) {
            // Request was cancelled, ignore
            return;
          }
          console.error('Search error:', e);
          this.loading = false;
        });
    },
  },
  mounted() {

    $('#searchModal').on('shown.bs.modal', () => {
      $('#searchModal').find('input#search_item').trigger('focus');
    });
    this.$root.$off('modal.change');
    this.$root.$on('modal.change', data => {
      $('#' + this.$store.state.data.modal).modal('show');
    });
  },
  components: {
    SearchRender,
    recommendRender,
    analogsRender,
  },
  name: "search"
}
</script>

<style scoped>
/* Component-specific overrides for search modal */
.modal-dialog-v2 {
  max-width: 1060px;
}

.loading-container-v2 {
  padding: 40px 20px;
  background: white;
  border-radius: 8px;
  margin-top: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
</style>
